// Web shim for @bam.tech/react-native-image-resizer
// On web we can't resize images the same way; return the original
export const createResizedImage = (_uri, _width, _height, _format, _quality) =>
  Promise.reject(new Error('Image resizing is not supported on web'));

export default { createResizedImage };
